/**
 * Route công khai cho khách xem ảnh in — nằm NGOÀI `_app` nên không qua cổng
 * đăng nhập. Token trên đường dẫn là quyền duy nhất.
 *
 * File này chỉ khai báo route, không dựng component nào — cùng khuôn
 * `album.$token.tsx` và `chon-anh.$token.tsx`.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PrintShareRoute } from "@/features/print-photos/PrintShareRoute";

export const Route = createFileRoute("/anh-in/$token")({
  component: PrintShareRoute,
});
